import { render, staticRenderFns } from "./EmptyPlaceholder.vue?vue&type=template&id=807baf76&scoped=true&"
import script from "./EmptyPlaceholder.vue?vue&type=script&lang=js&"
export * from "./EmptyPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807baf76",
  null
  
)

export default component.exports